import { WorldConstants } from '../_constants';
const initialState = {
  details: undefined,
  error: undefined,
  loading: false,
  params: undefined,
  subgroups: [],
};
export function world(state = initialState, action) {
  switch (action.type) {
    case WorldConstants.POPULATE_WORLD:
      return {
        ...state,
        details: action.world,
        error: undefined,
        loading: undefined,
      };

    case WorldConstants.GET_SUBGROUPS_REQUEST:
      return {
        ...state,
        loading: true,
        error: undefined,
        params: action.params,
      };

    case WorldConstants.GET_SUBGROUPS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: undefined,
        params: undefined,
        subgroups: action.groups,
      };

    case WorldConstants.GET_SUBGROUPS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
        params: undefined,
        subgroups: undefined,
      };
    default:
      return state;
  }
}
